export enum RouteEnums {
  Dashboard = '/dashboard/',
  Login = '/login',
  SignUp = '/signup',
  EmailVerification = '/email-verification',
  EmailConfirmation = '/email-confirmation',
  ChooseDealSpace = '/choose-dealspace',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  ConnectPlaybook = '/connect-playbook',
  Notifications = '/notifications/',
  AcceptPlayBookInvitiation = '/accept-playbook-invitation',
  AcceptDealspaceInvitiation = '/accept-dealspace-invitation',
  CreateDealspace = '/create-dealspace',
  ChooseExperience = '/choose-experience',
  Reports = '/reports/',
  DealspaceDirectory = '/dealspace-directory/',
  Milestone = '/milestone/',
  MyTasks = '/my-tasks/',
  MyRisks = '/my-risks/',
  MyIssues = '/my-issues/',
  MyDecisions = '/my-decisions/',
  DependenciesIn = '/dependencies-in/',
  Dependencies = '/dependencies/',
  DependenciesOut = '/dependencies-out/',
  ImoKnowledge = '/imo-knowledge/',
  ImoTools = '/imo-tools/',
  Settings = '/settings/',
  Playbook = '/playbook/',
  UserRegistered = '/userregistered',
  PricingAndPlans = '/pricing-and-plans',
  PaymentDetails = '/payment-details',
  BillingInfo = '/billing-info',
  PaymentMethod = '/payment-methods',
  PaymentPlan = '/payment-plan',
  ResultMessage = '/result-message',
  WorkstreamPlan = '/workstream-plan',
  PersonalTemplates = '/personal-templates/',
  PersonalTemplatesDetail = '/personal-templates-detail/',
  Subscription = '/subscription/',
}
